import { Col, Image, Row, Spin } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import apiClient from "../../Actions/apiClient";
import AssetPath from "../../AssetPath/AssetPath";
import PageTitle from "../../Components/PageTitle/PageTitle";

const GalleryDetail = () => {
  const { slug } = useParams();
  const [gallery, setGallery] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!slug) return;

    setLoading(true);
    apiClient
      .get(`galleries/slug/${slug}`)
      .then(({ data }) => {
        if (data && data.result) {
          setGallery(data.result);
        } else {
          setNotFound(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching gallery:", error);
        setNotFound(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [slug]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spin size="large" />
      </div>
    );
  }

  if (notFound || !gallery) {
    return (
      <div className="text-center py-5">
        <p className="text-secondary">Gallery not found.</p>
      </div>
    );
  }

  return (
    <>
      <PageTitle
        mainTitle={gallery.title}
        breadcrumbItems={[
          { name: "Gallery", path: "/gallery" },
          { name: gallery.title, path: `/gallery/${slug}` },
        ]}
        image={AssetPath.breadcrumb.galleryImage}
      />

      <section className="spacing">
        <div className="container">
          <div className="text-center mb-2">
            <h2 className="text-primary h3 mb-1">{gallery.title}</h2>
            {gallery.description && (
              <div
                className="fw-normal fst-italic"
                dangerouslySetInnerHTML={{ __html: gallery.description }}
              />
            )}
          </div>
          <Row gutter={[16, 24]}>
            {gallery.signedImages.map((item, i) => (
              <Col
                xs={{ span: 12 }}
                sm={{ span: 12 }}
                md={{ span: 8 }}
                lg={{ span: 8 }}
                key={i}
              >
                <div className="gallery-details card border p-2">
                  <Image
                    src={item.url}
                    alt={gallery.title}
                    className="w-100 mb-2"
                    loading="lazy"
                  />
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>
    </>
  );
};

export default GalleryDetail;